import React, { useState } from 'react';
import * as Yup from 'yup';
import Header from '../components/Layout/Header';
import '../scss/pages/home.css'
import '../scss/pages/bmi.css'
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';

const validationSchema = Yup.object().shape({
  height: Yup.number().required('Height is required').positive().min(1, 'Height must be greater than 0'),
  weight: Yup.number().required('Weight is required').positive().min(1, 'Weight must be greater than 0'),
});
const BmiCalculator = () => {
  const [bmiValue, setBmiValue] = useState(0);
  const {t} = useTranslation();
  const initialValues = {
    height: '',
    weight: '',
  };

  const calculateBmi = (height, weight) => {
    const heightInMeters = height / 100;
    return (weight / (heightInMeters * heightInMeters)).toFixed(2);
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const bmi = calculateBmi(values.height, values.weight);
      setBmiValue(bmi)
    },
  });

  return (
  <>
  <Header/>
    <div className='bmiWrapper'>
      <h2>{t('bmicontent.calculate')}</h2>
      <form onSubmit={formik.handleSubmit}>
        <div className='inputWrapper'>
          <label htmlFor="height">{t('bmicontent.height')}:</label>
          <input
            type="number"
            id="height"
            name="height"
            min={1}
            placeholder='Enter your height'
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.height}
          />
          {formik.touched.height && formik.errors.height ? (
            <div className="error">{formik.errors.height}</div>
          ) : null}
        </div>

        <div className='inputWrapper'>
          <label htmlFor="weight">{t('bmicontent.weight')}:</label>
          <input
            type="number"
            id="weight"
            name="weight"
            min={1}
            placeholder='Enter your weight'
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.weight}
          />
          {formik.touched.weight && formik.errors.weight ? (
            <div className="error">{formik.errors.weight}</div>
          ) : null}
        </div>

        <div className='bmiBtn'>
          <button type="submit">{t('bmicontent.calculate')}</button>
        </div>
      </form>
      <div className='bmiClass'>
        <h5>{t('bmicontent.bmi')} : <span style={(bmiValue> 25 || bmiValue < 19) && bmiValue > 0 ? {color: 'red'}: bmiValue > 19 && bmiValue < 25 ? {color: 'green'}: {color: '#000'}}>{bmiValue}</span></h5>
      </div>
      <div className='bmiContent'>
        {bmiValue > 25 ? <p>{t('bmicontent.overweight')}</p>: ''}
        {bmiValue < 19 && bmiValue > 0 ? <p>{t('bmicontent.underweight')}</p>: ''}
        {bmiValue > 19 && bmiValue < 25 ? <p>{t('bmicontent.fitweight')}</p>: ''}
      </div>
    </div>
    </>
  );
};

export default BmiCalculator;
